import React, { useState } from 'react';
import styled from 'styled-components';
import { useNavigate, useLocation } from 'react-router-dom';
import { IoChevronBack } from 'react-icons/io5';
import { FiTrash2 } from 'react-icons/fi';
import TopNav from '../components/TopNav';
import { useNoobookContext } from '../context/NoobookContext';
import { useEffect } from 'react';

const Wrapper = styled.div`
  max-width: 480px;
  margin: 0 auto;
  background: #fff;
  min-height: 100vh;
`;

const Content = styled.div`
  padding: 0 0 50px 0;
`;

const BannerImg = styled.img`
  width: 100%;
  height: 180px;
  object-fit: cover;
  border-radius: 0;
  display: block;
`;

const ProfileRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px 20px 0 20px;
`;

const ProfileImg = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #eaeaea;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #bbb;
`;

const ProfileInfo = styled.div`
  flex: 1;
  padding-left: 0;
`;

const ProfileInfoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 2px;
`;

const Nickname = styled.div`
  font-weight: bold;
  font-size: 1.1rem;
  color: #222;
`;

const UserId = styled.div`
  color: #888;
  font-size: 0.95rem;
`;

const Badge = styled.span`
  background: #e64980;
  color: #fff;
  font-size: 13px;
  border-radius: 4px;
  padding: 2px 4px;
  white-space: nowrap;
  display: inline-block;
  font-weight: 400;
  margin-left: 4px;
`;

const TagRow = styled.div`
  color: #888;
  font-size: 0.85rem;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-left: 0;
  margin-top: 0;
`;

// 탭 스타일
const TabRow = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1.5px solid #e0e0e0;
  background: #eae8e9;
  margin: 0;
`;

const Tab = styled.button`
  flex: 1;
  background: none;
  border: none;
  font-size: 17px;
  font-weight: 600;
  color: ${props => props.active ? '#222' : '#bdbdbd'};
  border-bottom: ${props => props.active ? '3px solid #222' : 'none'};
  padding: 14px 0 10px 0;
  cursor: pointer;
`;

const TabContent = styled.div`
  padding: 20px;
`;

const BookDescTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #222;
  margin-bottom: 12px;
`;

const BookDesc = styled.div`
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 24px;
`;

const BookInfoRow = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
`;

const BookCover = styled.img`
  width: 80px;
  height: 120px;
  border-radius: 4px;
  object-fit: cover;
  background: #eee;
`;

const BookInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 4px;
`;

const BookTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #222;
  margin-bottom: 0px;
`;

const BookAuthor = styled.div`
  font-size: 14px;
  color: #666;
`;

const InfoTable = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  row-gap: 4px;
  column-gap: 10px;
  margin-top: 8px;
  align-items: center;
  font-size: 0.9rem;
  text-align: left;
`;

const InfoLabelBadge = styled.span`
  background: ${({ gray }) => (gray ? '#666' : '#1976d2')};
  color: #fff;
  font-size: 0.9rem;
  border-radius: 4px;
  padding: 2px 4px;
  white-space: nowrap;
  display: inline-block;
  font-weight: 400;
`;

const CommentInputContainer = styled.div`
  margin-top: 20px;
  padding: 16px 0;
`;

const CommentInputWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

const CommentInput = styled.input`
  flex: 1;
  height: 36px;
  border: 1px solid #e1e1e1;
  border-radius: 18px;
  padding: 0 16px;
  font-size: 14px;
  background: #f7f7f7;
  box-sizing: border-box;
  
  &:focus {
    outline: none;
    border-color: #244AC2;
  }
`;

const CommentSubmitButton = styled.button`
  background: #888;
  color: white;
  border: none;
  border-radius: 16px;
  padding: 6px 12px;
  font-size: 12px;
  cursor: pointer;
  white-space: nowrap;
  
  &:hover {
    background: #666;
  }
  
  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
`;

// 커뮤니티 서브 탭 스타일
const CommunitySubTabRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 20px;
  padding: 4px 0 20px 0;
`;

const CommunitySubTab = styled.button`
  background: ${props => props.active ? '#333' : '#f5f5f5'};
  color: ${props => props.active ? '#fff' : '#666'};
  border: none;
  border-radius: 20px;
  padding: 6px 16px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
`;

const CommentsContainer = styled.div`
  margin-top: 16px;
`;

const CommentItem = styled.div`
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
  
  &:last-child {
    border-bottom: none;
  }
`;

const CommentHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
`;

const CommentAuthor = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #222;
`;

const CommentDate = styled.div`
  font-size: 12px;
  color: #888;
`;

const CommentContent = styled.div`
  font-size: 14px;
  color: #333;
  line-height: 1.5;
`;

const DeleteButton = styled.button`
  background: none;
  border: none;
  color: #999;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    background: #f5f5f5;
    color: #e74c3c;
  }
`;

// 샘플 데이터
const sampleBookListData = {
  bookTitle: '1984',
  participationDate: '2024년 1월 15일',
  participationTime: '14:00 ~ 16:00',
  participantCount: '10명',
  participationType: '온라인',
  participationCondition: '도서를 미리 읽고 참여해주세요. 발제문은 미리 준비해서 오시면 됩니다.',
  presentationDocument: '1. 작품의 주요 테마와 메시지는 무엇인가요?\n2. 현재 사회와 비교했을 때 어떤 점이 유사하고 다른가요?\n3. 빅브라더의 존재가 개인의 자유에 미치는 영향은 무엇인가요?',
  leader: {
    nickname: '독서광',
    userId: '@reader123',
    badge: '리더',
    tags: ['소설', '디스토피아', '고전'],
    profileImg: null
  }
};

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function BookListDetailPage() {
  const navigate = useNavigate();
  const query = useQuery();
  const title = query.get('title');
  const { setShowBack, setLogoText } = useNoobookContext();
  const [activeTab, setActiveTab] = useState('community');
  const [communityTab, setCommunityTab] = useState('booklist');
  const [commentInput, setCommentInput] = useState('');
  const [comments, setComments] = useState([]);

  useEffect(() => {
    setShowBack(true);
    setLogoText('도서리스트 상세');
    return () => setShowBack(false);
  }, [setShowBack, setLogoText]);

  const bookList = sampleBookListData;

  const handleCommentSubmit = () => {
    if (!commentInput.trim()) {
      alert('댓글을 입력해주세요.');
      return;
    }
    
    const newComment = {
      id: Date.now(),
      author: '나',
      date: new Date().toLocaleDateString('ko-KR'),
      content: commentInput.trim()
    };
    
    setComments(prev => [newComment, ...prev]);
    setCommentInput('');
  };

  const handleCommentKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleCommentSubmit();
    }
  };

  const handleDeleteComment = (commentId) => {
    if (window.confirm('댓글을 삭제하시겠습니까?')) {
      setComments(prev => prev.filter(comment => comment.id !== commentId));
    }
  };

  return (
    <Wrapper>
      <Content>
        <BannerImg src="/book_sample.jpg" alt="banner" />
        
        {/* 홈/커뮤니티 탭 */}
        <TabRow>
          <Tab active={activeTab==='home'} onClick={()=>navigate('/moim-detail')}>홈</Tab>
          <Tab active={activeTab==='community'} onClick={()=>setActiveTab('community')}>커뮤니티</Tab>
        </TabRow>



                    {/* 홈 탭 내용 */}
            {activeTab === 'home' && (
              <TabContent>
                <BookDescTitle>도서 소개</BookDescTitle>
                <BookDesc>
                  이번 도서리스트에서는 조지 오웰의 '1984'를 함께 읽고 토론합니다. 
                  디스토피아 소설의 대표작으로 현대 사회의 감시와 통제에 대한 깊이 있는 논의를 나누어보겠습니다.
                </BookDesc>
                
                <BookInfoRow>
                  <BookCover src="/book_sample.jpg" alt={bookList.bookTitle} />
                  <BookInfo>
                    <BookTitle>{bookList.bookTitle}</BookTitle>
                    <BookAuthor>조지 오웰</BookAuthor>
                    <InfoTable>
                      <InfoLabelBadge>참여일자</InfoLabelBadge><div>{bookList.participationDate}</div>
                      <InfoLabelBadge>참여시간</InfoLabelBadge><div>{bookList.participationTime}</div>
                      <InfoLabelBadge>참여인원</InfoLabelBadge><div>{bookList.participantCount}</div>
                      <InfoLabelBadge gray style={{textAlign: 'center'}}>참여형태</InfoLabelBadge><div>{bookList.participationType}</div>
                    </InfoTable>
                  </BookInfo>
                </BookInfoRow>
                
                <BookDescTitle>참여조건</BookDescTitle>
                <BookDesc>{bookList.participationCondition}</BookDesc>
                
                <BookDescTitle>발제문</BookDescTitle>
                <BookDesc style={{whiteSpace: 'pre-line'}}>{bookList.presentationDocument}</BookDesc>
                
                {/* 댓글 입력창 */}
                <CommentInputContainer>
                  <CommentInputWrapper>
                    <CommentInput 
                      placeholder="답글을 입력해주세요"
                      value={commentInput}
                      onChange={(e) => setCommentInput(e.target.value)}
                      onKeyPress={handleCommentKeyPress}
                    />
                    <CommentSubmitButton onClick={handleCommentSubmit}>
                      작성
                    </CommentSubmitButton>
                  </CommentInputWrapper>
                </CommentInputContainer>
          </TabContent>
        )}

        {/* 커뮤니티 탭 내용 */}
        {activeTab === 'community' && (
          <TabContent>
            {/* 커뮤니티 서브 탭 */}
            <CommunitySubTabRow>
              <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}>
                <div style={{display: 'flex', gap: '8px', alignItems: 'center'}}>
                  <CommunitySubTab 
                    active={communityTab === 'booklist'} 
                    onClick={() => navigate('/moim-detail?tab=community&subtab=booklist')}
                  >
                    도서리스트
                  </CommunitySubTab>
                  <CommunitySubTab 
                    active={communityTab === 'freeboard'} 
                    onClick={() => navigate('/moim-detail?tab=community&subtab=freeboard')}
                  >
                    자유게시판
                  </CommunitySubTab>
                </div>
              </div>
            </CommunitySubTabRow>

            {/* 도서리스트 탭 */}
            {communityTab === 'booklist' && (
              <>
                <BookDescTitle>도서 소개</BookDescTitle>
                <BookDesc>
                  이번 도서리스트에서는 조지 오웰의 '1984'를 함께 읽고 토론합니다. 
                  디스토피아 소설의 대표작으로 현대 사회의 감시와 통제에 대한 깊이 있는 논의를 나누어보겠습니다.
                </BookDesc>
                
                <BookInfoRow>
                  <BookCover src="/book_sample.jpg" alt={bookList.bookTitle} />
                  <BookInfo>
                    <BookTitle>{bookList.bookTitle}</BookTitle>
                    <BookAuthor>조지 오웰</BookAuthor>
                    <InfoTable>
                      <InfoLabelBadge>참여일자</InfoLabelBadge><div>{bookList.participationDate}</div>
                      <InfoLabelBadge>참여시간</InfoLabelBadge><div>{bookList.participationTime}</div>
                      <InfoLabelBadge>참여인원</InfoLabelBadge><div>{bookList.participantCount}</div>
                      <InfoLabelBadge gray style={{textAlign: 'center'}}>참여형태</InfoLabelBadge><div>{bookList.participationType}</div>
                    </InfoTable>
                  </BookInfo>
                </BookInfoRow>
                
                <BookDescTitle>참여조건</BookDescTitle>
                <BookDesc>{bookList.participationCondition}</BookDesc>
                
                <BookDescTitle>발제문</BookDescTitle>
                <BookDesc style={{whiteSpace: 'pre-line'}}>{bookList.presentationDocument}</BookDesc>
                
                {/* 댓글 입력창 */}
                <CommentInputContainer>
                  <CommentInputWrapper>
                    <CommentInput 
                      placeholder="답글을 입력해주세요"
                      value={commentInput}
                      onChange={(e) => setCommentInput(e.target.value)}
                      onKeyPress={handleCommentKeyPress}
                    />
                    <CommentSubmitButton onClick={handleCommentSubmit}>
                      작성
                    </CommentSubmitButton>
                  </CommentInputWrapper>
                </CommentInputContainer>
                
                {/* 댓글 목록 */}
                {comments.length > 0 && (
                  <CommentsContainer>
                    {comments.map((comment) => (
                      <CommentItem key={comment.id}>
                        <CommentHeader>
                          <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                            <CommentAuthor>{comment.author}</CommentAuthor>
                            <CommentDate>{comment.date}</CommentDate>
                            {comment.author === "나" && (
                              <DeleteButton onClick={(e) => {
                                e.stopPropagation();
                                handleDeleteComment(comment.id);
                              }}>
                                <FiTrash2 size={12} />
                              </DeleteButton>
                            )}
                          </div>
                        </CommentHeader>
                        <CommentContent>{comment.content}</CommentContent>
                      </CommentItem>
                    ))}
                  </CommentsContainer>
                )}
              </>
            )}

            {/* 자유게시판 탭 */}
            {communityTab === 'freeboard' && (
              <div>
                <BookDescTitle>자유게시판</BookDescTitle>
                <BookDesc>
                  이 도서리스트의 자유게시판입니다. 
                  참여자들과 함께 도서에 대한 의견을 나누고 토론할 수 있습니다.
                </BookDesc>
              </div>
            )}
          </TabContent>
        )}
      </Content>
    </Wrapper>
  );
} 